import { parseSlugDate } from 'helpers/date';

const initialState = [];

import { GET_VIEWABLE_BASKETS_V3_RESPONSE } from 'lib/constants/v3Actions';

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_VIEWABLE_BASKETS_V3_RESPONSE: {
      const basketMenuSlugs = action.response.weeklyBaskets.map(basket => basket.menuSlug);
      const menuSlugs = action.response.missingBasketMenus.map(mbm => mbm.menuSlug);
      return basketMenuSlugs.concat(menuSlugs).sort((a, b) => parseSlugDate(a) - parseSlugDate(b));
    }
    default:
      return state;
  }
};

export const selectV3DashboardMenuSlugs = state => state.v3.dashboard.menuSlugs;
